import { render, staticRenderFns } from "./private-cloud.vue?vue&type=template&id=efde8ab2&"
import script from "./private-cloud.vue?vue&type=script&lang=js&"
export * from "./private-cloud.vue?vue&type=script&lang=js&"
import style0 from "./private-cloud.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports